export default __webpack_public_path__ + "static/media/dcine.6b4821d0.png";